import React, { Component, Fragment } from 'react';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Checkbox } from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { forceDirtyState, resetDirty } from 'State/dirtyTracking/actions';
import { MANAGE_KITCHEN_ITEM_FORM_NAME } from 'Common/FormEnum';
import { LoadingPage, TrackedCheckbox } from 'Components';
import { resetForm } from 'State/forms/actions';
import { BidGroupEnum, FilterEnum, KitchenItemsEnum } from 'Common/FieldEnum';
import {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  clearFilterErrorMsg,
} from 'State/filters/actions';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { ReactTableColumnProperties } from 'Common/Constants';
import * as FilterSelector from 'State/filters/selectors';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';

import * as actions from '../state/actions';
import KitchenItemsComponent from '../components/KitchenItemsComponent';
import {
  prepareSaveKitchenItemsPayload,
  prepareKitchenItemIdsArray,
} from './../helper/index';
import * as Selectors from './../state/selectors';

class KitchenItemsContainer extends Component {
  static propTypes = {
    kitchenItems: PropTypes.array.isRequired,
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    submitted: PropTypes.bool.isRequired,
    itemsSubmitted: PropTypes.bool.isRequired,
    fetchKitchenItemsLoading: PropTypes.bool.isRequired,

    assignItemsBidGroupData: PropTypes.array.isRequired,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    fetchingDropdown: PropTypes.bool.isRequired,
    fetchKitchenItemsError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),

    resetForm: PropTypes.func.isRequired,
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    clearFilterErrorMsg: PropTypes.func.isRequired,
    forceDirtyState: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    setYesNoDialogProps: PropTypes.func.isRequired,
  };

  reactTableRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      activeIndexForFilter: GenericEnum.InitialFilterValue,
      filterValues: {
        [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
        [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
      },
      sorted: [],
      filtered: [],
      kitchenItemIds: [],
      page: 0,
    };

    this.columns = [
      {
        Header: () => {
          const dataObj =
            this.reactTableRef && this.reactTableRef.current
              ? this.reactTableRef.current.getResolvedState()
              : { sortedData: this.props.kitchenItems };
          const isAllKitchenItemsChecked = this.isAllKitchenItemsChecked(
            dataObj.sortedData
          );
          return (
            <div>
              <div>Kitchen Item</div>
              <Checkbox
                checked={isAllKitchenItemsChecked}
                onChange={(e, data) => {
                  e.stopPropagation();
                  this.props.forceDirtyState();
                  this.checkAll(data.checked, dataObj.sortedData);
                }}
              />
            </div>
          );
        },
        accessor: KitchenItemsEnum.PrepareInHouse,
        width: 150,
        sortable: true,
        Cell: ({ original }) => {
          const initialValue = _.find(this.props.kitchenItems, {
            [KitchenItemsEnum.Id]: original[KitchenItemsEnum.Id],
          })[KitchenItemsEnum.PrepareInHouse];
          return (
            <div style={{ textAlign: 'center' }}>
              <TrackedCheckbox
                initialValue={initialValue}
                checked={this.state.kitchenItemIds.includes(
                  original[KitchenItemsEnum.Id]
                )}
                onChange={(e, data) => {
                  if (data.checked) {
                    this.setState({
                      kitchenItemIds: [
                        ...this.state.kitchenItemIds,
                        original[KitchenItemsEnum.Id],
                      ],
                    });
                  } else {
                    const kitchenItemIdsCopy = [...this.state.kitchenItemIds];
                    const indexOfItem = kitchenItemIdsCopy.indexOf(
                      original[KitchenItemsEnum.Id]
                    );
                    kitchenItemIdsCopy.splice(indexOfItem, 1);
                    this.setState({ kitchenItemIds: kitchenItemIdsCopy });
                  }
                }}
              />
            </div>
          );
        },
      },
      {
        Header: 'Item Code',
        width: 250,
        accessor: KitchenItemsEnum.ItemCode,
        ...ReactTableColumnProperties,
      },
      {
        Header: 'Description',
        accessor: KitchenItemsEnum.Description,
        ...ReactTableColumnProperties,
      },
    ];
  }

  async componentDidMount() {
    const {
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getKitchenItems,
    } = this.props;

    getBidGroupForCurrentSite(BidGroupEnum.UnassignedAndAll);
    getItemGroupForCurrentSite();
    await getKitchenItems();
    this.setState({
      kitchenItemIds: prepareKitchenItemIdsArray(this.props.kitchenItems),
    });
  }

  componentDidUpdate(prevProps) {
    const {
      clearKitchenItemErrors,
      clearFilterErrorMsg,
      getKitchenItems,
    } = this.props;
    if (
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError')
    ) {
      clearFilterErrorMsg();
    }
    if (
      errorToast(this.props, prevProps, 'fetchKitchenItemsError') ||
      errorToast(this.props, prevProps, 'submitError')
    ) {
      clearKitchenItemErrors();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Kitchen Item(s) has been saved',
        true
      );
      clearKitchenItemErrors();
      getKitchenItems();
      this.props.resetDirty();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  getMainProps = () => {
    const { itemsSubmitted, fetchKitchenItemsLoading } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Save',
            loading: itemsSubmitted,
            disabled: itemsSubmitted || fetchKitchenItemsLoading,
            onClick: this.onSaveButtonClick,
          },
        ],
        shown: true,
      },
    };
  };

  handleChange = (e, values) => {
    this.setState({ filterValues: values, page: 0 });
  };

  checkAll = (checked, items) => {
    const kitchenItemIdsCopy = [...this.state.kitchenItemIds];
    if (items && Array.isArray(items) && items.length) {
      items.forEach(item => {
        const itemId = item[KitchenItemsEnum.Id]
          ? item[KitchenItemsEnum.Id]
          : item._original[KitchenItemsEnum.Id];
        const index = kitchenItemIdsCopy.indexOf(itemId);
        if (checked && index === -1) {
          kitchenItemIdsCopy.push(itemId);
        } else if (!checked && index > -1) {
          kitchenItemIdsCopy.splice(index, 1);
        }
      });
      this.setState({ kitchenItemIds: kitchenItemIdsCopy });
    }
  };

  isAllKitchenItemsChecked = items => {
    const { kitchenItemIds } = this.state;
    if (
      !items ||
      !Array.isArray(items) ||
      !items.length ||
      !kitchenItemIds.length
    ) {
      return false;
    }
    return items.every(item => {
      const itemId = item[KitchenItemsEnum.Id]
        ? item[KitchenItemsEnum.Id]
        : item._original[KitchenItemsEnum.Id];
      return kitchenItemIds.includes(itemId);
    });
  };

  clearFilters = () => {
    const { change } = this.props;
    change(FilterEnum.GroupId_Bid, GenericEnum.InitialFilterValue);
    change(FilterEnum.GroupId_Item, GenericEnum.InitialFilterValue);
    this.setState({
      filterValues: {
        [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
        [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
      },
      sorted: [],
      filtered: [],
      page: 0,
    });
  };

  onSortedChange = (sorted, column, shiftKey) => {
    this.setState({ sorted, page: 0 });
  };
  onFilteredChange = (filtered, column) => {
    this.setState({ filtered, page: 0 });
  };

  handleClick = () => {
    this.setState({ activeIndexForFilter: !this.state.activeIndexForFilter });
  };

  onSaveButtonClick = () => {
    this.props.setYesNoDialogProps({
      showDialog: true,
      title: 'Kitchen Items',
      question: 'Are you sure you want to save the changes?',
      yesCallback: () => this.onSaveClick(true),
      noCallback: () => this.onSaveClick(false),
    });
  };

  onSaveClick = flag => {
    const dataObj =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: this.props.kitchenItems };

    const filteredKitchenItems = _.forEach(dataObj.sortedData, item => {
      item[KitchenItemsEnum.Id] = item[KitchenItemsEnum.Id]
        ? item[KitchenItemsEnum.Id]
        : item._original[KitchenItemsEnum.Id];
    });

    if (flag) {
      const payload = prepareSaveKitchenItemsPayload(
        this.state.kitchenItemIds,
        filteredKitchenItems
      );
      this.props.saveKitchenItems(payload);
    }
  };

  onPageChange = page => {
    this.setState({ page });
  };

  onPageSizeChange = (currentPageSize, currentPage) => {
    this.setState({
      page: currentPage,
    });
  };

  render() {
    const {
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      fetchingDropdown,
      kitchenItems,
      fetchKitchenItemsLoading,
    } = this.props;
    const { filterValues, sorted, filtered, page } = this.state;

    const filterValuesData = {};
    _.map(filterValues, (value, key, items) => {
      if (+items[key]) {
        filterValuesData[key] = items[key];
      }
    });

    const filteredData = Object.keys(filterValuesData).length
      ? _.filter(kitchenItems, filterValuesData)
      : kitchenItems;

    return (
      <Fragment>
        {fetchingDropdown ? (
          <LoadingPage />
        ) : (
          <KitchenItemsComponent
            activeIndexForFilter={this.state.activeIndexForFilter}
            handleClick={this.handleClick}
            assignItemsBidGroupData={assignItemsBidGroupData}
            assignItemsItemGroupData={assignItemsItemGroupData}
            kitchenItems={filteredData}
            fetchKitchenItemsLoading={fetchKitchenItemsLoading}
            getMainProps={this.getMainProps}
            filterValues={filterValues}
            handleChange={this.handleChange}
            clearFilters={this.clearFilters}
            sorted={sorted}
            onSortedChange={this.onSortedChange}
            filtered={filtered}
            onFilteredChange={this.onFilteredChange}
            columns={this.columns}
            onSaveClick={this.onSaveClick}
            reactTableRef={this.reactTableRef}
            page={page}
            onPageChange={this.onPageChange}
            onPageSizeChange={this.onPageSizeChange}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(MANAGE_KITCHEN_ITEM_FORM_NAME)(state));

  return {
    kitchenItems: Selectors.getKitchenItemsData(state),
    submitError: Selectors.getSubmitErrorData(state),
    submitted: Selectors.getSubmittedData(state),
    itemsSubmitted: Selectors.getItemsSubmitted(state),
    fetchKitchenItemsLoading: Selectors.getFetchKitchenItemsLoading(state),
    fetchKitchenItemsError: Selectors.getFetchKitchenItemsError(state),
    assignItemsBidGroupData: FilterSelector.getBidGroupData(state),
    assignItemsItemGroupData: FilterSelector.getItemGroupData(state),
    bidGroupDataError: FilterSelector.getBidGroupDataError(state),
    itemGroupDataError: FilterSelector.getItemGroupDataError(state),
    fetchingDropdown:
      FilterSelector.getBidGroupDataLoading(state) ||
      FilterSelector.getItemGroupDataLoading(state),
    initialValues: {
      [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
    },
  };
};

KitchenItemsContainer = reduxForm({
  form: MANAGE_KITCHEN_ITEM_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(KitchenItemsContainer);

const mapDispatchToProps = {
  ...actions,
  resetForm,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  clearFilterErrorMsg,
  forceDirtyState,
  resetDirty,
  setYesNoDialogProps,
};

export const KitchenItems = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(KitchenItemsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenitems/containers/KitchenItems.js